import { Business, Help, Person } from '@mui/icons-material';
import Home from '@mui/icons-material/Home';
import { Route } from 'react-router-dom';
import { FEATURE_FLAGS } from '../lib/featureFlags/featureFlagConstants';
import { AccountInfoPage } from '../pages/AccountInfo';
import { AdminDashboardPage } from '../pages/AdminDashboard';
import { CreateOrganizationPage } from '../pages/CreateOrganization';
import { CreateSubscriptionPage } from '../pages/CreateSubscription';
import { EditOrganizationPage } from '../pages/EditOrganization';
import { AdvancedTopics } from '../pages/Help/AdvancedTopics';
import { GettingStarted } from '../pages/Help/GettingStarted';
import { HelpPage } from '../pages/Help/HelpPage';
import { LocalCommunicationPage } from '../pages/Help/LocalCommunication';
import { UdpKeysPage } from '../pages/Help/UdpKeys';
import { HomePage } from '../pages/HomePage';
import { ManageInstallersPage } from '../pages/ManageInstallers';
import { OrganizationDetailsPage } from '../pages/OrganizationDetails';
import { OrganizationListPage } from '../pages/OrganizationList';
import { SubscriptionDetailsPage } from '../pages/SubscriptionDetails';
import i18n from '../translations/i18n';
import { FeatureFlagRoute } from './FeatureFlagRoute';

export const HomeDrawerPages = [
    {
        title: i18n.t('COMMON.HOME'),
        route: '/',
        component: HomePage,
        icon: Home,
        iconTestId: 'home-page-icon',
    },
];

export const DrawerPages = [
    {
        title: i18n.t('DRAWER.HELP'),
        route: '/help',
        component: HelpPage,
        icon: Help,
        iconTestId: 'help-page-icon',
    },
];

export const DrawerDocumentationPages = (
    <>
        <Route path="/advancedTopics" element={<AdvancedTopics />} />
        <Route path="/advancedTopics/udpKeys" element={<UdpKeysPage />} />
        <Route path="/advancedTopics/localCommunication" element={<LocalCommunicationPage />} />
        <Route path="/gettingStarted" element={<GettingStarted />} />
    </>
);

export const AuthorizedDrawerPages = [
    {
        title: i18n.t('DRAWER.MY_ORGANIZATIONS'),
        route: '/organizations',
        component: OrganizationListPage,
        icon: Business,
        iconTestId: 'organization-list-page-icon',
    },
];

export const AdminDrawerPages = [
    {
        title: 'Organization Requests',
        route: '/adminDashboard',
        component: AdminDashboardPage,
        icon: Person,
        iconTestId: 'admin-page-icon',
    },
    {
        title: i18n.t('CREATE_SUBSCRIPTION_PAGE.TITLE'),
        route: '/createSubscription',
        component: CreateSubscriptionPage,
        icon: Person,
        iconTestId: 'create-subscription-page-icon',
    },
];

export const AuthorizedPages = (
    <>
        <Route path="/account" element={<AccountInfoPage />} />
        <Route path="/organizations/:id" element={<OrganizationDetailsPage />} />
        <Route path="/organizations/create" element={<CreateOrganizationPage />} />
        <Route path="/organizations/:id/edit" element={<EditOrganizationPage />} />
        <Route
            path="/organizations/:id/manageInstallers"
            element={
                <FeatureFlagRoute flag={FEATURE_FLAGS.INSTALLER_INVITATION_ENABLED} redirectTo="/">
                    <ManageInstallersPage />
                </FeatureFlagRoute>
            }
        />
        <Route path="/subscriptionDetails" element={<SubscriptionDetailsPage />} />
    </>
);
